import { useAuth } from '../context/AuthContext';

/**
 * Returns the active organization id for multi-organization modules.
 * Super admins (and admins with multiple orgs) operate on the organization
 * selected in the top-bar Org Switcher (currentOrg). Falls back to the
 * user's own organization when no selection is available.
 */
export function useOrgId() {
  const { currentOrg, user } = useAuth();
  return currentOrg?.id || user?.organization_id || null;
}
